export const MerchantSelectionConfirmDialogErrorViewUat = {
  title: 'merchantSelection.ConfirmDialog.error.title',
  description: 'merchantSelection.ConfirmDialog.error.description',
  closeIcon: 'merchantSelection.ConfirmDialog.error.closeIcon'
}
